import {combineReducers} from 'redux';

import institute from '../reducer/InstituteReducer';
import branch from '../reducer/BranchReducer';
import admission from '../reducer/AdmissionReducer';
import global from '../reducer/GlobalReducer';



const reducer = combineReducers({
    institute,
    branch,
    admission,
    global
});



export default reducer;

